module.exports = __webpack_public_path__ + "static/media/visa-mastercard.bf7b9ad3.png";